module.exports = __webpack_public_path__ + "img/image_of_content_before_load.ec10423d.gif";